import { i as header, n as mapHeader, t as GatsbyClient } from "./gatsby-client-Nkjavnkw.mjs";
//#region src/namespaces/client.ts
const getHeader = () => mapHeader(header);
//#endregion
export { GatsbyClient, getHeader };
